import { legacyMPC, MPC } from './MPC';

const renameChildren = (array, newName = '') => array
  .map(({ name, path, ...child }) => (({
    name: `${newName}${name}`,
    path: path.replace('MPC/', ''),
    ...child
  })));

export const legacyChatbot = {
  path: '/chatbot',
  name: 'Chatbot',
  component: () => import('@/layouts/legacyChatbot'),
  children: [
    ...renameChildren(legacyMPC.children, 'Chatbot')
  ]
};

export const Chatbot = {
  path: '/chatbot',
  name: 'Chatbot',
  component: () => import('@/layouts/Chatbot'),
  children: [
    ...renameChildren(MPC.children, 'Chatbot')
  ]
};

export default Chatbot;
